import React, { useState } from 'react'
import AdminPermission from '../../../../Component/edit_permission/admin_permission'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const AdminPermissionDialog = (props) => {
 
    const handleSubmit = ()=>{
        props.onSubmit(props.data.adminId)
    }
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            {/* <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Modal heading
                </Modal.Title>
            </Modal.Header> */}
            <Modal.Body>
                <AdminPermission
                    selectedRoles={props.fieldValues}
                    setSelectedRoles={props.setFieldValue}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleSubmit}>Renew</Button>
                <Button onClick={props.onHide} variant="secondary">Close</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default React.memo(AdminPermissionDialog)